export default __webpack_public_path__ + "static/media/typeP_low.01e6e92c.png";